import { TFactoryId } from '@monorepo/types';

export interface TMMFactoryState {
  factoryId: TFactoryId;
  userName: string;
}

export const TMMFactoryActionTypes = {
  SetFactoryId: 'SET_FACTORY_ID',
  SetUserName: 'SET_USER_NAME',
} as const;
